import { Box, Icon, Tag, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { PostDataFragment } from 'generated/resources/graphql'
import moment from 'moment'

import { observer } from 'mobx-react'

interface ItemProps {
  post: PostDataFragment
}

const Event = ({ post }: ItemProps) => {
  const localeData = moment.localeData()
  const timeFormat = localeData.longDateFormat('LLLL')
  const time = moment.parseZone(post.startsAt).local().format(timeFormat)
  const type = post.type.split('::').pop()
  const isEvent = type === 'Event'
  const isLongLocationName = isEvent && post.location ? post.location.length > 15 : false
  const [openLocationToolTip, toggleLocationToolTip] = useToggle(false)

  return (
    <Box flexDirection="row" gap="s12" overflowX="hidden">
      {isEvent && (
        <Box paddingBottom="s48">
          <Tag type="grey">
            <Box flexDirection="row" gap="s1" alignItems="center">
              <Icon.Medium icon="calendar" />
              {time}
            </Box>
          </Tag>
        </Box>
      )}
      {isEvent && post.location && (
        <Box paddingBottom="s48">
          {isLongLocationName ? (
            <Tooltip.Alt
              attachment="bottom center"
              targetAttachment="top center"
              toggle={toggleLocationToolTip}
              open={openLocationToolTip}
              label={post.location}
            >
              <Tag type="grey">
                <Box flexDirection="row" gap="s1" alignItems="center">
                  <Icon.Medium icon="office" />
                  {post.location}
                </Box>
              </Tag>
            </Tooltip.Alt>
          ) : (
            <Tag type="grey">
              <Box flexDirection="row" gap="s1" alignItems="center">
                <Icon.Medium icon="office" />
                {post.location}
              </Box>
            </Tag>
          )}
        </Box>
      )}
    </Box>
  )
}

export default observer(Event)
